import styles from './index.module.css'

import React from 'react'

import { FilterComponentProps, FilterOperatorOption } from 'types/filter-page'

import { Flex, Text, TextField } from 'components/ds'

import { useKeyPress } from 'hooks/use-key-press'

import { FilterOperatorSelector } from '../../filter-operator-selector'

const DateForm = ({
  label,
  value,
  onChange,
  operator = 'equals',
  onPress,
}: FilterComponentProps) => {
  const { handleKeyDown } = useKeyPress('Enter', onPress)

  // Helper function to create date inputs
  const createDateInput = (
    inputValue: string,
    onChangeHandler: (_value: string) => void,
    shouldAutoFocus = true,
    hasError = false,
    doubleInput = false,
  ) => (
    <TextField.Root
      type="date"
      value={inputValue || ''}
      onChange={e => onChangeHandler(e.target.value)}
      onKeyDown={handleKeyDown}
      placeholder={label}
      autoFocus={shouldAutoFocus}
      style={{
        width: doubleInput ? '125px' : '273px',
        ...(hasError ? { boxShadow: 'inset 0 0 0 1px var(--red-8)' } : {}),
      }}
      className={styles.dateInput}
    />
  )

  const allFilterOperators: FilterOperatorOption[] = [
    {
      value: 'equals',
      component: createDateInput(value || '', newValue => {
        onChange(newValue, operator)
      }),
    },
    {
      value: 'between',
      component: (
        <>
          <Flex gap="2" align="center">
            {createDateInput(
              value?.[0] || '',
              newValue => {
                const updatedValue = !newValue
                  ? ['', value?.[1] || '']
                  : [newValue, value?.[1] || '']

                onChange(updatedValue, operator)
              },
              true,
              Array.isArray(value) && !value[0] && value[1],
              true,
            )}
            <Text size="2">-</Text>
            {createDateInput(
              value?.[1] || '',
              newValue => {
                const updatedValue = !newValue
                  ? [value?.[0] || '', '']
                  : [value?.[0] || '', newValue]

                onChange(updatedValue, operator)
              },
              false,
              Array.isArray(value) && value[0] && !value[1],
              true,
            )}
          </Flex>
        </>
      ),
    },
    {
      value: 'lte',
      component: createDateInput(value || '', newValue => {
        onChange(newValue, operator)
      }),
    },
    {
      value: 'gte',
      component: createDateInput(value || '', newValue => {
        onChange(newValue, operator)
      }),
    },
  ]

  return (
    <FilterOperatorSelector
      operator={operator}
      onChange={onChange}
      operators={allFilterOperators}
    />
  )
}

export default DateForm
